import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        login(res.data.user);
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (error) {
        console.error("Auth exchange failed:", error);
        navigate("/login", { replace: true });
      }
    };
    exchangeSession();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
